import Alert from "../alert";
import { useState } from "react";

function EditUserModal({ showEdituser, handleClose }) {

    const [viewAlert, setViewAlert] = useState(false);

    return (
        <>
            {/* Alert */}
            <Alert
                show={viewAlert}
                message="User updated successfully!"
                type="success"
                onClose={() => setViewAlert(false)}
            />

            {/* Modal */}
            <div
                className={`modal fade ${showEdituser ? "show d-block" : ""}`}
                tabIndex="-1"
                style={{
                    backgroundColor: showEdituser
                        ? "rgba(0,0,0,0.5)"
                        : "transparent"
                }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">
                                <strong>Update User</strong>
                            </h5>

                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>

                        <div className="modal-body">
                           <form className="row g-3">
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="First Name" value="Adrian"/>
                                </div>
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="Last Name" value="Smith"/>
                                </div>
                                 <div className="col-12">
                                    <input type="text" className="form-control" placeholder="Username"  value="yanyan@05"/>
                                </div>
                                <div className="col-md-6">
                                    <input type="email" className="form-control" placeholder="Email" value="adrian.smith@example.com"/>
                                </div>
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="Address" value="123 Main St"/>
                                </div>
                                <div className="col-md-6">
                                    <input type="password" className="form-control" placeholder="Current Password" />
                                </div>
                                <div className="col-md-6">
                                    <input type="password" className="form-control" placeholder="New Password"/>
                                </div>
                                <div className="col-md-6">
                                    <input type="File" className="form-control" placeholder="Choose Profile" />
                                </div>
                                <div className="col-md-6">
                                    <select id="inputState" className="form-select" value="Full Admin">
                                        <option selected>Choose Role</option>
                                        <option>Master Admin</option>
                                        <option>Full Admin</option>
                                        <option>Temporary Admin</option>
                                    </select>
                                </div>
                            </form>
                            {/* <!-- End No Labels Form --> */}
                        </div>

                        <div className="modal-footer">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    setViewAlert(true);
                                    handleClose();
                                }}
                            >
                                Save Updates
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default EditUserModal;